/*
 * © Crown © Crown Copyright 2026. Published by the Royal Government of the Dominion of Atlantis.
 * 
 * Licensed under the Juro Restricted License Version 2. You may not change and/or modify 
 * this work except under the terms of the Juro Restricted License. 
 * See <https://docs.juro.net/legal/JRL_V2_COMPLETE/> for details.
 */

function format(str, args) {
	if (str == undefined) return str;

	this.unkeyed_index = 0;
	return str.replace(
		/\{(\w*)\}/g,
		function (match, key) {
			if (key === "") {
				key = this.unkeyed_index;
				this.unkeyed_index++;
			}
			if (key == +key) {
				return args[key] !== undefined ? args[key] : match;
			}
		}.bind(this)
	);
}

if (jQuery) {
	jQuery.format = format;
}
